
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentsService {
  public contentType = new BehaviorSubject(<any>'');
  public subjectClosed = new Subject<any>();

  constructor(private _apiService: ApiService) { }

  createContent(data: any) {
    const formData = new FormData();
    Object.entries(data).forEach(([keyy, valuee]) => {
      Object.entries(valuee).forEach(([key, value]) => {
        if (key !== 'tagged_interests_attributes' && key !== 'content_prices_attributes') {
          formData.set(`content[${keyy}][${key}]`, value as string);
        } else if (key == 'tagged_interests_attributes') {
          Object.entries(valuee['tagged_interests_attributes']).forEach(([k, v]) => {
            Object.entries(v).forEach((k1) => {
              formData.set(`content[${keyy}][${key}][${k}][${k1[0]}]`, k1[1].toString() as string);
            })

          });
        }
        else if ((key == 'content_prices_attributes')) {
          Object.entries(value).forEach(([priceKey, priceValue]) => {
            Object.entries(priceValue).forEach(([k1, v1]) => {
              formData.set(`content[${keyy}][${key}][${priceKey}][${k1}]`, v1.toString() as string);
            })
          })
        }
      })
    });
    return this._apiService.post(environment.url + '/v1/contents/bulk_create', formData, '', {
      reportProgress: true,
      observe: 'events'
    })
  }

  createWIPODcontent(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.WIPOD_CONTENT_CREATE}`
    const formData = new FormData();
    Object.entries(data).forEach(([keyy, valuee]) => {
      Object.entries(valuee).forEach(([key, value]) => {
        if (key !== 'tagged_interests_attributes' && key !== 'content_prices_attributes') {
          formData.set(`content[${key}]`, value as string);
        } else if (key == 'tagged_interests_attributes') {
          Object.entries(valuee['tagged_interests_attributes']).forEach(([k, v]) => {
            Object.entries(v).forEach((k1) => {
              formData.set(`content[${key}][${k}][${k1[0]}]`, k1[1].toString() as string);
            })

          });
        }
        else if ((key == 'content_prices_attributes')) {
          Object.entries(value).forEach(([priceKey, priceValue]) => {
            Object.entries(priceValue).forEach(([k1, v1]) => {
              formData.set(`content[${key}][${priceKey}][${k1}]`, v1.toString() as string);
            })
          })
        }
      })
    });
    return this._apiService.post(url, formData, '', {
      reportProgress: true,
      observe: 'events'
    })
  }

  updateContent(data, contentId) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}/${contentId}`
    const formData = new FormData();
    Object.entries(data.content).forEach(([key, value]) => {
      if (key !== 'tagged_interests_attributes' && key !== 'content_prices_attributes') {
        formData.set(`content[${key}]`, value as string);
      }
      else if (key == 'tagged_interests_attributes') {
        Object.entries(data.content['tagged_interests_attributes']).forEach(([k, v]) => {
          Object.entries(v).forEach((k1) => {
            formData.set(`content[${key}][${k}][${k1[0]}]`, k1[1].toString() as string);
          })
        });
      }
      else if ((key == 'content_prices_attributes')) {
        Object.entries(value).forEach(([priceKey, priceValue]) => {
          Object.entries(priceValue).forEach(([k1, v1]) => {
            formData.set(`content[${key}][${priceKey}][${k1}]`, v1.toString() as string);
          })
        })
      }
    })
    if (data.no_of_clicks >= 0) {
      formData.set(`no_of_clicks`, data.no_of_clicks.toString() as string);
    }
    return this._apiService.put(url, formData);
  }

  updateWIPOD(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.WIPOD_DOC_UPDATE}`
    const formData = new FormData();
    Object.entries(data.content).forEach(([key, value]) => {
      if (key !== 'tagged_interests_attributes' && key !== 'content_prices_attributes' && key !== 'content_texts') {
        formData.set(`content[${key}]`, value as string);
      }
      else if (key == 'tagged_interests_attributes') {
        Object.entries(data.content['tagged_interests_attributes']).forEach(([k, v]) => {
          Object.entries(v).forEach((k1) => {
            formData.set(`content[${key}][${k}][${k1[0]}]`, k1[1].toString() as string);
          })
        });
      }
      else if ((key == 'content_prices_attributes')) {
        Object.entries(value).forEach(([priceKey, priceValue]) => {
          Object.entries(priceValue).forEach(([k1, v1]) => {
            formData.set(`content[${key}][${priceKey}][${k1}]`, v1.toString() as string);
          })
        })
      }
      else if ((key == 'content_texts')) {
        Object.entries(value).forEach(([priceKey, priceValue]) => {
          Object.entries(priceValue).forEach(([k1, v1]) => {
            formData.set(`content[${key}][${priceKey}][${k1}]`, v1.toString() as string);
          })
        })
      }
    })
    if (data.no_of_clicks >= 0) {
      formData.set(`no_of_clicks`, data.no_of_clicks.toString() as string);
    }
    if (data.id) {
      formData.set(`id`, data.id.toString() as string);
    }
    return this._apiService.put(url, formData);
  }

  getEventClosed(): Observable<any> {
    return this.subjectClosed.asObservable();
  }

  getPresignedUrl(params) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.PRESIGNED_URL}`
    return this._apiService.put(url, params);
  }

  watchContentType(): Observable<any> {
    return this.contentType.asObservable();
  }

  privateToPublic(data, id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}/${id}${API_ENDPOINTS.API.PUBLISH_TO_PUBLIC_LIBRARY}`
    return this._apiService.put(url, data)
  }

  getHotDeals() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.HOT_DEAL}`;
    return this._apiService.get(url);
  }

  getMostPopularVideo() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.MOST_POPULAR_VIDEO}`;
    return this._apiService.get(url);
  }

  getEditorPickedVideo() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.EDITORS_CHOICE}${API_ENDPOINTS.API.EDITOR_VIDEO}`;
    return this._apiService.get(url);
  }

  getMaterialType(queryParam?) {
    let url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}${API_ENDPOINTS.API.MATERIAL}`;
    if (queryParam) {
      url += ('?' + queryParam);
    }
    return this._apiService.get(url);
  }

  getTemplateByID(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.API.TEMPLATES}${API_ENDPOINTS.API.MATERIAL_TEMPLATES}`;
    return this._apiService.post(url, data);
  }

  saveEventRegistration(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.EVENT_REGISTRATION}`;
    return this._apiService.post(url, data);
  }

  checkEventEmail(params) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.EVENT_REGISTRATION}/unique_email?email_id=${params}`;
    return this._apiService.get(url);
  }

  previewPDF(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONTENTS}/generate_pdf`;
    return this._apiService.post(url, data);
  }
}
